import React, { Fragment, useState, useEffect, useRef } from 'react'

import { useSelector } from 'react-redux'
import { FiCopy, FiCheckCircle, FiShoppingBag, FiDollarSign, FiCreditCard, FiLink, FiSmartphone, FiMonitor, FiAlertTriangle } from 'react-icons/fi';
import { useHistory } from "react-router-dom";
// copy to clipboard
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Icon } from '@iconify/react';
import CloseIcon from '@material-ui/icons/Close';
import copyFill from '@iconify/icons-eva/copy-fill';
// import { CopyToClipboard } from 'react-copy-to-clipboard';

import {
  Grid,
  Card,
  Typography,
  Box,
  Divider,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  InputAdornment,
  IconButton,
  Tooltip,
  Hidden,
  Container,
  AppBar,
  Toolbar,
  LinearProgress,
  Avatar

} from "@mui/material";

import { Alert } from '@material-ui/lab'
//qrcode
import QRCode from 'react-qr-code'

//utils
import { getValorTotal, getValorTotal2, getValorSubTotal, soNumeros } from '../../utils/functions';

import splitZoop from '../../actions/zoop/splitZoop';
import transactionZoop from '../../actions/zoop/transactionZoop';
// import getDataFilial from '../../actions/zoop/getDataFilial';
import editAfterSplit from '../../actions/zoop/editAfterSplit';
import afterSaleZoop from '../../actions/zoop/afterSaleZoop';
//images
import Happy from '../../images/happy-01.png';
// actions
import buscarFilialPorCodigoFilial from '../../actions/cadastro/buscar-filial-por-codigo-filial';
import getPedidoByNumber from '../../actions/pedidos/pedido-by-number'
import { useLocation } from 'react-router-dom';
import PaymentModalMoovpay from '../../sections/payment/PaymentModalMoovpay';
import actionLoginMoovpay from '../../actions/moovpay/actionLoginMoovpay';
import actionGerarQrcodeMoovpay from '../../actions/moovpay/actionGerarQrcodeMoovpay';
import actionVerificarPagamentoMoovpay from '../../actions/moovpay/actionVerificarPagamentoMoovpay';
import actionCriarTransacaoZoop from '../../actions/zoop/actionCriarTransacaoZoop';
import actionCriarPedidoPagarme from '../../actions/pagarme/actionCriarPedidoPagarme';
import axios from 'axios';

// Função para obter o IP do usuário
const obterIPUsuario = async () => {
  try {
    const response = await axios.get('https://api.ipify.org?format=json');
    return response.data.ip;
  } catch (error) {
    console.error('Erro ao obter IP:', error);
    // Retorna um IP padrão em caso de erro
    return "186.248.250.50";
  }
};

// Função para gerar hash único
const gerarHash = () => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};

const cardSx = {
  p: { xs: 2.5, md: 3 },
  borderRadius: 2.5,
  border: '1px solid',
  borderColor: 'grey.200',
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  bgcolor: '#fff'
};

const buttonSx = {
  bgcolor: '#1a1a2e',
  color: '#fff',
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: 1.5,
  '&:hover': {
    bgcolor: '#16213e'
  }
};

const sectionHeaderAvatarSx = {
  width: 36,
  height: 36,
  bgcolor: '#e8eaf0',
  color: '#1a1a2e'
};

const infoBoxSx = {
  bgcolor: '#eff6ff',
  border: '1px solid #bfdbfe',
  color: '#1e40af',
  borderRadius: 2,
  px: 2,
  py: 1.5
};

const successBoxSx = {
  bgcolor: '#f0fdf4',
  border: '1px solid #bbf7d0',
  color: '#166534',
  borderRadius: 2,
  px: 2,
  py: 1.5
};

const ConclusaoPage = () => {
  const history = useHistory();
  const [infoPedido, setInfoPedido] = useState('');
  const [items, setItems] = useState([]);
  const [numeroWhatsapp, setNumeroWhatsapp] = useState('');
  const [dddWhatsapp, setDddWhatsapp] = useState('');
  const [idWhatsapp, setIdWhatsapp] = useState('');
  const [copiedLink, setCopiedLink] = useState('');
  const [dialogResultPayment, setDialogResultPayment] = useState(false);
  const [copiedBoleto, setCopiedBoleto] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [dadosFilial, setDadosFilial] = useState('');
  const [alertTransaction, setAlertTransaction] = useState('');
  const [dataAlertTransactionError, setDataAlertTransactionError] = useState('');
  const [dataResultPix, setDataResultPix] = useState('');
  const orderNumber = useSelector(state => state.orderNumber);
  //const orderNumber = '10903';
  const [dialogEnviarWhatsapp, setDialogEnviarWhatsapp] = useState(false);
  const location = useLocation();
  // Extrai o parâmetro de consulta "channel" da string de busca (search) da URL
  const params = new URLSearchParams(location.search);
  const order = params.get('order');

  const [qrcodeMoovpay, setQrcodeMoovpay] = useState(null);
  const [openModalMoovpay, setOpenModalMoovpay] = useState(false);

  const intervalIdRef = useRef(null);
  const intervalPixPagarmeRef = useRef(null);


  const handleClickCloseModalEnviarWhatsapp = () => {
    setDialogEnviarWhatsapp(false);
  };

  const BoxDescriptionItem = ({ label, value }) => {
    return (
      <Box sx={{ flexDirection: 'column', bgcolor: '#f8f9fa', borderRadius: 2, p: 1.5, border: '1px solid', borderColor: 'grey.200' }}>
        <Typography variant='caption' sx={{ color: 'text.secondary' }}>{label}</Typography>
        <Typography variant='h6' sx={{ fontWeight: 700 }}>{value}</Typography>
      </Box>
    );
  }

  const onCopy = () => {
    setCopiedLink(true);

  };

  const onCopyPix = () => {
    setCopiedBoleto(true);
    // enqueueSnackbar('Copiado código Pix', { variant: 'success' });

  };

  const handleChangeCopyBoleto = (event) => {
    setCopiedBoleto(false);
  };



  const handleChangeCopyLink = () => {
    setCopiedLink(false);
  };

  async function handleVerificarPagamentoMoovpay() {
    try {

      const response = await actionVerificarPagamentoMoovpay(infoPedido?._id);
      if (response.status === 200) {
        if (response.data.response === "ok") {
          setTimeout(() => {
            window.location.href = "/pdv/conclusao?order="+infoPedido.number;
          }, 5000);
        }
      }

    } catch (error) {
      console.log('error', error)
    }
  }



  const handleCobrarMoovpay = async () => {

    try {
      let data = {
        "scope": {
          "valor": Math.round(getValorTotal2(infoPedido)),
          "orderNumber": infoPedido.number
        }

      }
      const response = await actionGerarQrcodeMoovpay(data);
      if (response.status === 200) {
        setQrcodeMoovpay(response.data.response);

        intervalIdRef.current = setInterval(() => {
          handleVerificarPagamentoMoovpay()
                }, 10000);
      }
    } catch (error) {

    }

  }

  const cobrarPixPagarme = async () => {
    setLoadingButton(true);
    try {
      // Obter IP do usuário
      const ipUsuario = await obterIPUsuario();

      // Extrair dados do endereço de entrega
      const shippingAddress = infoPedido.shipping_address;
      const phone = shippingAddress?.phone || '';
      let numberOnly = phone.replace(/\D/g, '');
      const areaCode = numberOnly.substring(0, 2);
      const phoneNumber = numberOnly.substring(2);

      // Calcular valor total em centavos

      const payload = {
        code: infoPedido._id,
        customer: {
          name: infoPedido.first_name + " " + infoPedido.last_name,
          type: "individual",
          document_type: "cpf",
          document: infoPedido.cpf,
          phones: {
            mobile_phone: {
              country_code: "55",
              number: phoneNumber,
              area_code: areaCode
            }
          }
        },
        shipping: {
          address: {
            line_1: shippingAddress?.address1 || "",
            line_2: shippingAddress?.details || "",
            zip_code: shippingAddress?.postal_code || "",
            city: shippingAddress?.city || "",
            state: shippingAddress?.state || "",
            country: "BR"
          },
          amount: Math.round(infoPedido.shipping_price * 100),
          description: "Entrega Katuxa",
          recipient_name: infoPedido.first_name + " " + infoPedido.last_name,
          recipient_phone: phoneNumber
        },
        items: infoPedido.items.map(item => ({
          amount: Math.round(item.price_total * 0.9 * 100),
          description: item.name,
          quantity: item.quantity,
          code: item.product_id
        })),
        ip: ipUsuario,
        session_id: gerarHash(),
        device: {
          platform: "WEB"
        },
        payments: [
          {
            payment_method: "pix",
            pix: {
              expires_in: 600
            }
          }
        ]
      };

      const response = await actionCriarPedidoPagarme(payload);
      // Pega os dados do QRCode e copia e cola do response
      const charge = response.data.charges && response.data.charges[0];
      const lastTransaction = charge && charge.last_transaction;
      if (lastTransaction && lastTransaction.qr_code && lastTransaction.qr_code_url) {
        setDataResultPix({
          qr_code: lastTransaction.qr_code,
          qr_code_url: lastTransaction.qr_code_url
        });
        setDialogResultPayment(true);
        // Inicia verificação periódica do pagamento
        iniciarVerificacaoPagamentoPixPagarme();
      }
      return response.data;
    } catch (error) {
      console.error('Erro ao gerar Pix Pagarme:', error.response ? error.response.data : error);
      throw error;
    } finally {
      setLoadingButton(false);
    }
  };

  // Função para verificar o pagamento do Pix Pagarme a cada 10 segundos
  const iniciarVerificacaoPagamentoPixPagarme = () => {
    if (intervalPixPagarmeRef.current) {
      clearInterval(intervalPixPagarmeRef.current);
    }
    intervalPixPagarmeRef.current = setInterval(async () => {
      try {
        const res = await getPedidoByNumber(order);
        if (res.data && res.data.status_id === '60774fb684e6861cb41a4730') {
          clearInterval(intervalPixPagarmeRef.current);
          window.location.href = "/pdv/pagamento-sucesso?order=" + res.data.number;
        }
      } catch (err) {
        // Pode logar erro se quiser
      }
    }, 10000);
  };

  // Limpa o intervalo ao desmontar o componente
  useEffect(() => {
    return () => {
      if (intervalPixPagarmeRef.current) {
        clearInterval(intervalPixPagarmeRef.current);
      }
    };
  }, []);

  const cobrarPix = async () => {
    setLoadingButton(true);

    try {
      const res = await actionCriarTransacaoZoop({
        //on_behalf_of:dadosFilial.sellerZoop,
        on_behalf_of: dadosFilial.sellerZoop,
        payment_type: "pix",
        description: `${infoPedido.number}_P`,
        currency: "BRL",
        amount: Math.round(getValorTotal2(infoPedido) * 100)
      })

      afterSaleZoop({
        number: infoPedido.number,
        responseZoop: res.data,
        status_id: "60774fa684e6861cb41a472f",
        isPaid: false
      }).catch(error => console.log(error));

      if (res.data.status === "pending") {
        setDataResultPix(res.data);
        setDialogResultPayment(true);

        let dataSplit = {
          id: res.data.id,
          sellerId: dadosFilial.sellerZoop,
          valorInCents: Math.round(getValorTotal2(infoPedido) * 100)
        }

        splitZoop(dataSplit).then(res => {
          console.log('Split, deu certo', res.data)
          editAfterSplit({ number: infoPedido.number, isSplitSuccess: true }).then(() => { }).catch(() => console.log('Erro ao gravar isSplitSuccess como Ok o split'));
        }).catch(err => {
          console.log('Split, deu errado', err)
          editAfterSplit({ number: infoPedido.number, isSplitSuccess: false }).then(() => { }).catch(() => console.log('Erro ao gravar isSplitSuccess como Erro o split'));
        });

      }

    } catch (e) {
      console.log('erro', e);
      if (e.response) {
        console.log('error repsonse', e.response.data.error);

        setAlertTransaction('failed')
        setLoadingButton(false);
        // scrollToBottom();
        setTimeout(() => {
          setAlertTransaction('');

        }, 15000);
      } else {
        setAlertTransaction('failed', e.response)
        setDataAlertTransactionError("Verifique os dados do Cartão e tente novamente, 1");
        setLoadingButton(false);
        //scrollToBottom();
        setTimeout(() => {
          setAlertTransaction('');
        }, 15000);
      }
    }


  }



  function validaPagamento(string) {
    if (string === "6168e68dbec438dc351a3065") {
      return "Cartão Crédito - Zoop";
    } else if (string === "6168e69ebec438dc351a3066") {
      return "Cartão Débito - Zoop";
    } else if (string === "6168e6afbec438dc351a3067") {
      return "Link Pagamento";
    } else if (string === "6168e6b7bec438dc351a3068") {
      return "Dinheiro";
    } else if (string === "62c753914e8a07e77586dc82") {
      return "Pix Checkout";
    } else if (string === "65ef574e94335d158c264b32") {
      return "Moovpay";
    }

  }

  const abrirLinkNovaAba = id => {
    let url = `https://pag.vkholding.com.br/${id}`;
    window.open(url, '_blank');
  }


  const abrirTerminaldePagamentos = () => {
    let url = `https://pagamento.katuxa.com.br`;
    window.open(url, '_blank');
  }


  const abrirModalWhatsappWeb = (phone, id) => {
    setIdWhatsapp(id);
    setDialogEnviarWhatsapp(true);
    //let url = `https://api.whatsapp.com/send?phone=${phone}&text=Aqui está o link de pagamento \n  https://pag.katuxa.com.br/payment/${id}`;
    //window.open(url, '_blank');
  }

  const abrirWhatsappWeb = () => {
    let whatsapp = dddWhatsapp + numeroWhatsapp;
    let url = `https://api.whatsapp.com/send?phone=55${whatsapp}&text=Aqui está o link de pagamento \n  https://pag.vkholding.com.br/${idWhatsapp}`;
    window.open(url, '_blank');
  }

  useEffect(() => {
    // Cleanup interval on component unmount
    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
    };
  }, []);

  const ResultPix = ({ dataResultPix }) => {
    return (
      <Grid maxWidth="md" item>
        <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h6" paragraph>
            Escaneie o QRCode
          </Typography>
          <Grid item>
            <QRCode value={dataResultPix.qr_code} />
          </Grid>

          <Typography sx={{ mt: 2.5, fontWeight: 700 }} variant="h3" paragraph>
            ou
          </Typography>

          <Typography variant="h6" paragraph>
            copie o codigo para pagamento em sua Instituicao Financeira
          </Typography>
          {dataResultPix && (
            <Grid sx={{ mt: 2.5, mb: 2.5 }} item md={12} sm={12} xs={12}>
              <TextField
                fullWidth
                disabled
                value={dataResultPix.qr_code}
                onChange={handleChangeCopyBoleto}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CopyToClipboard text={dataResultPix.qr_code} onCopy={onCopyPix}>
                        <Tooltip title="Copiar Pix Copia e Cola">
                          <IconButton>
                            <Icon icon={copyFill} width={24} height={24} />
                          </IconButton>
                        </Tooltip>
                      </CopyToClipboard>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
          )}
          <Box sx={{ ...infoBoxSx, mt: 1, width: '100%' }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              <FiAlertTriangle style={{ marginRight: 6, verticalAlign: 'middle' }} />
              Efetue o pagamento em ate 5 minutos, apos esse tempo, o Pix nao podera ser pago.
            </Typography>
          </Box>
        </Box>
      </Grid>
    );
  }



  useEffect(() => {

    getPedidoByNumber(order).then(res => {
      console.log('res', res.data)
      setInfoPedido(res.data)
      setItems(res.data.items);
      buscarFilialPorCodigoFilial(res.data.items[0].filial).then(dataFilial => {
        setDadosFilial(dataFilial.data);
      }).catch(err => console.log('err', err))


    }).catch(err => {
      //window.location.href = "/pdv";
      console.log(err)
    });

  }, []);



  return (
    <>
      <PaymentModalMoovpay
        open={openModalMoovpay}
        onClose={() => {
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
          }
          setOpenModalMoovpay(false);
        }}
        qrcode={qrcodeMoovpay}
      />

      {/* Dialog Pix Result - Full Screen */}
      <Dialog fullScreen open={dialogResultPayment}>
        <AppBar sx={{ bgcolor: '#1a1a2e', boxShadow: 'none' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setDialogResultPayment(false)}
              sx={{ bgcolor: '#e53935', '&:hover': { bgcolor: '#c62828' } }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100%' }}>
          <Box sx={{ mt: 10 }}>
            {infoPedido.payment_method_id === '62c753914e8a07e77586dc82' && <ResultPix dataResultPix={dataResultPix} />}
          </Box>
        </Grid>
      </Dialog>

      {/* Dialog Whatsapp */}
      <Dialog open={dialogEnviarWhatsapp} onClose={handleClickCloseModalEnviarWhatsapp} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Abrir Whatsapp Web</DialogTitle>
        <DialogContent>
          <Grid spacing={2} container>
            <Grid item md={4}>
              <TextField
                autoFocus
                maxLength={2}
                label="DDD"
                variant='outlined'
                fullWidth
                onChange={event => setDddWhatsapp(event.target.value)}
              />
            </Grid>
            <Grid item md={8}>
              <TextField
                autoFocus
                variant='outlined'
                label="Numero"
                fullWidth
                onChange={event => setNumeroWhatsapp(event.target.value)}
              />
            </Grid>
          </Grid>
          <Typography sx={{ mt: 1.5, color: 'text.secondary', fontSize: '0.875rem' }}>
            Por favor, digite somente NUMEROS
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickCloseModalEnviarWhatsapp} sx={{ textTransform: 'none', color: 'text.secondary' }}>
            Cancelar
          </Button>
          <Button
            disabled={!(dddWhatsapp && numeroWhatsapp)}
            onClick={abrirWhatsappWeb}
            sx={buttonSx}
          >
            Abrir Whatsapp
          </Button>
        </DialogActions>
      </Dialog>

      {/* Main Page */}
      <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>

        {/* Header */}
        <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5', py: 2 }}>
          <Box sx={{ maxWidth: '98%', mx: 'auto' }}>
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Avatar sx={sectionHeaderAvatarSx}>
                <FiCheckCircle size={18} />
              </Avatar>
              <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
                Conclusao do Pedido
              </Typography>
            </Stack>
          </Box>
        </Box>

        {/* Content */}
        <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>

          {/* Success Card */}
          <Box sx={{ ...cardSx, mb: 3 }}>
            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
              <Avatar sx={{ ...sectionHeaderAvatarSx, bgcolor: '#f0fdf4', color: '#166534' }}>
                <FiCheckCircle size={18} />
              </Avatar>
              <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
                Pedido Realizado
              </Typography>
            </Stack>

            <Box sx={successBoxSx}>
              <Typography sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' }, fontWeight: 600, textAlign: 'center' }}>
                Pedido <strong>#{infoPedido.number}</strong> foi realizado com sucesso!
              </Typography>
            </Box>
          </Box>

          {/* Order Summary Card */}
          <Box sx={{ ...cardSx, mb: 3 }}>
            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
              <Avatar sx={sectionHeaderAvatarSx}>
                <FiShoppingBag size={18} />
              </Avatar>
              <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
                Resumo do Pedido
              </Typography>
            </Stack>

            <Grid spacing={2} container>
              <Grid item md xs={6}>
                <BoxDescriptionItem label="Frete" value={"R$ " + infoPedido.shipping_price} />
              </Grid>
              <Grid item md xs={6}>
                <BoxDescriptionItem label="Subtotal" value={"R$ " + getValorSubTotal(items)} />
              </Grid>
              <Grid item md xs={6}>
                <BoxDescriptionItem label="Total do Pedido" value={"R$ " + getValorTotal(items, infoPedido.shipping_price, infoPedido.desconto, infoPedido.ajuste)} />
              </Grid>
              <Grid item md xs={6}>
                <BoxDescriptionItem label="Forma de Pagamento" value={validaPagamento(infoPedido.payment_method_id)} />
              </Grid>
            </Grid>
          </Box>

          {/* Payment Action Card */}
          <Box sx={{ ...cardSx }}>
            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
              <Avatar sx={sectionHeaderAvatarSx}>
                <FiDollarSign size={18} />
              </Avatar>
              <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
                Pagamento
              </Typography>
            </Stack>

            <Divider sx={{ mb: 3 }} />

            {/* Cartao Credito */}
            {infoPedido.payment_method_id === '6168e68dbec438dc351a3065' && (
              <Stack alignItems="center" spacing={2}>
                <Box sx={infoBoxSx}>
                  <Typography sx={{ textAlign: 'center', fontSize: '0.95rem' }}>
                    Foi selecionado a forma de pagamento Cartao na Loja, abra o{' '}
                    <Button
                      variant='outlined'
                      onClick={abrirTerminaldePagamentos}
                      sx={{ textTransform: 'none', fontWeight: 600, borderColor: '#1a1a2e', color: '#1a1a2e', mx: 0.5 }}
                    >
                      Terminal de Pagamentos
                    </Button>{' '}
                    e complete o pagamento por la usando o numero do pedido abaixo
                  </Typography>
                </Box>
                <Box sx={{ bgcolor: '#f8f9fa', borderRadius: 2, px: 5, py: 1, border: '1px solid', borderColor: 'grey.200' }}>
                  <Typography variant='h3' sx={{ fontWeight: 700 }}>{infoPedido.number}</Typography>
                </Box>
              </Stack>
            )}

            {/* Cartao Debito */}
            {infoPedido.payment_method_id === '6168e69ebec438dc351a3066' && (
              <Stack alignItems="center" spacing={2}>
                <Box sx={infoBoxSx}>
                  <Typography sx={{ textAlign: 'center', fontSize: '0.95rem' }}>
                    Foi selecionado a forma de pagamento Cartao na Loja, abra o{' '}
                    <Button
                      variant='outlined'
                      onClick={abrirTerminaldePagamentos}
                      sx={{ textTransform: 'none', fontWeight: 600, borderColor: '#1a1a2e', color: '#1a1a2e', mx: 0.5 }}
                    >
                      Terminal de Pagamentos
                    </Button>{' '}
                    e complete o pagamento por la usando o numero do pedido abaixo
                  </Typography>
                </Box>
                <Box sx={{ bgcolor: '#f8f9fa', borderRadius: 2, px: 5, py: 1, border: '1px solid', borderColor: 'grey.200' }}>
                  <Typography variant='h3' sx={{ fontWeight: 700 }}>{infoPedido.number}</Typography>
                </Box>
              </Stack>
            )}

            {/* Dinheiro */}
            {infoPedido.payment_method_id === '6168e6b7bec438dc351a3068' && (
              <Box>
                <Box sx={infoBoxSx}>
                  <Typography sx={{ fontSize: '0.95rem', mb: 1.5 }}>
                    Foi selecionado a forma de pagamento Dinheiro, Clique no link abaixo e retire o Boleto
                  </Typography>
                </Box>
                <Box sx={{ mt: 2, bgcolor: '#f8f9fa', borderRadius: 2, p: 2, border: '1px solid', borderColor: 'grey.200', wordBreak: 'break-all' }}>
                  {infoPedido.link_pagamento}
                </Box>
              </Box>
            )}

            {/* Pix Checkout */}
            {infoPedido.payment_method_id === '62c753914e8a07e77586dc82' && (
              <Grid container sx={{ justifyContent: 'center' }}>
                <Grid item md={8} xs={12}>
                  {loadingButton === true ? (
                    <LinearProgress sx={{ borderRadius: 1 }} />
                  ) : (
                    <Button
                      onClick={cobrarPixPagarme}
                      fullWidth
                      sx={{ ...buttonSx, height: 56, fontSize: '1rem' }}
                    >
                      Gerar PIX
                    </Button>
                  )}

                  <Box sx={{ ...infoBoxSx, mt: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      <FiAlertTriangle style={{ marginRight: 6, verticalAlign: 'middle' }} />
                      Apos clicar em "Gerar Pix", o PIX ficara disponivel por 5 minutos.
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            )}

            {/* Moovpay */}
            {infoPedido.payment_method_id === '65ef574e94335d158c264b32' && (
              <Grid container sx={{ justifyContent: 'center' }}>
                <Grid item md={8} xs={12}>
                  {!qrcodeMoovpay && (
                    loadingButton === true ? (
                      <LinearProgress sx={{ borderRadius: 1 }} />
                    ) : (
                      <>
                        {infoPedido.status_id === '60774fb684e6861cb41a4730' ? (
                          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
                            <Stack spacing={2} direction="column" alignItems="center" justifyContent="center">
                              <Icon icon="flat-color-icons:ok" style={{ fontSize: 100 }} />
                              <Typography sx={{ textAlign: 'center', fontWeight: 600 }}>
                                Pagamento Realizado com sucesso
                              </Typography>
                            </Stack>
                          </Box>
                        ) : (
                          <Button
                            onClick={handleCobrarMoovpay}
                            fullWidth
                            sx={{ ...buttonSx, height: 50, fontSize: '1rem' }}
                          >
                            Gerar QRCODE Moovpay !
                          </Button>
                        )}
                      </>
                    )
                  )}
                  {qrcodeMoovpay && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
                      <Stack spacing={2} direction="column" justifyContent="center" alignItems="center">
                        <Typography sx={{ textAlign: 'center', fontWeight: 600 }}>
                          Escaneie o QRCode
                        </Typography>
                        <QRCode
                          size={256}
                          style={{ height: "auto", maxWidth: 200, width: 200 }}
                          value={qrcodeMoovpay}
                          viewBox={`0 0 256 256`}
                        />
                      </Stack>
                    </Box>
                  )}
                  <Box sx={{ ...infoBoxSx, mt: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      <FiAlertTriangle style={{ marginRight: 6, verticalAlign: 'middle' }} />
                      Apos clicar em "Gerar Qrcode", efetue o pagamento imediatamente
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            )}

            {/* Link Pagamento */}
            {infoPedido.payment_method_id === '6168e6afbec438dc351a3067' && (
              <Box>
                <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
                  <Avatar sx={sectionHeaderAvatarSx}>
                    <FiLink size={18} />
                  </Avatar>
                  <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
                    Confira as opcoes para compartilhar o link de Pagamento
                  </Typography>
                </Stack>

                <Grid spacing={3} container>
                  {/* Opcao 1 */}
                  <Grid md={4} xs={12} item>
                    <Box sx={{ ...cardSx, height: '100%', bgcolor: '#fafafa' }}>
                      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
                        <Avatar sx={{ ...sectionHeaderAvatarSx, width: 28, height: 28 }}>
                          <FiMonitor size={14} />
                        </Avatar>
                        <Typography sx={{ fontWeight: 700, fontSize: '0.95rem' }}>Opcao 1</Typography>
                      </Stack>
                      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                        Abra o link em uma nova aba ou envie por Whatsapp
                      </Typography>
                      <Grid container spacing={1.5}>
                        <Grid item md xs={12}>
                          <Button
                            fullWidth
                            onClick={() => abrirLinkNovaAba(infoPedido._id)}
                            sx={buttonSx}
                          >
                            Abrir em nova aba
                          </Button>
                        </Grid>
                        {infoPedido.shipping_address && (
                          <Grid item md xs={12}>
                            <Button
                              fullWidth
                              onClick={() => abrirModalWhatsappWeb(infoPedido.shipping_address.phone, infoPedido._id)}
                              sx={{ ...buttonSx, bgcolor: '#16a34a', '&:hover': { bgcolor: '#15803d' } }}
                            >
                              Abrir no Whatsapp Web
                            </Button>
                          </Grid>
                        )}
                      </Grid>
                    </Box>
                  </Grid>

                  {/* Opcao 2 */}
                  <Grid md={4} xs={12} item>
                    <Box sx={{ ...cardSx, height: '100%', bgcolor: '#fafafa' }}>
                      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
                        <Avatar sx={{ ...sectionHeaderAvatarSx, width: 28, height: 28 }}>
                          <FiCopy size={14} />
                        </Avatar>
                        <Typography sx={{ fontWeight: 700, fontSize: '0.95rem' }}>Opcao 2</Typography>
                      </Stack>
                      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                        Copie o link clicando no botao abaixo
                      </Typography>
                      <TextField
                        fullWidth
                        disabled
                        value={`https://pag.vkholding.com.br/${infoPedido._id}`}
                        onChange={handleChangeCopyLink}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <CopyToClipboard text={`https://pag.vkholding.com.br/${infoPedido._id}`} onCopy={onCopy}>
                                <Tooltip title="Copiar Boleto">
                                  <IconButton>
                                    <FiCopy size={24} />
                                  </IconButton>
                                </Tooltip>
                              </CopyToClipboard>
                            </InputAdornment>
                          )
                        }}
                      />
                    </Box>
                  </Grid>

                  {/* Opcao 3 */}
                  <Grid md={4} xs={12} item>
                    <Box sx={{ ...cardSx, height: '100%', bgcolor: '#fafafa' }}>
                      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
                        <Avatar sx={{ ...sectionHeaderAvatarSx, width: 28, height: 28 }}>
                          <FiSmartphone size={14} />
                        </Avatar>
                        <Typography sx={{ fontWeight: 700, fontSize: '0.95rem' }}>Opcao 3</Typography>
                      </Stack>
                      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                        Abra a camera ou App Leitor de QrCode de um SmartPhone e envie facilmente o LINK para o seu cliente
                      </Typography>
                      <Box sx={{ textAlign: 'center', mt: 2 }}>
                        <QRCode size={150} value={`https://pag.vkholding.com.br/${infoPedido._id}`} />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>

        </Box>
      </Box>
    </>
  )
}

export default ConclusaoPage;
